export default __webpack_public_path__ + "static/media/church_line_drawing.7fc9c871.jpg";